(function() {
    'use strict';
    angular
        .module('functional7App')
        .factory('Gimnasio', Gimnasio);

    Gimnasio.$inject = ['$resource', 'DateUtils'];

    function Gimnasio ($resource, DateUtils) {
        var resourceUrl =  'api/gimnasios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaAlta = DateUtils.convertLocalDateFromServer(data.fechaAlta);
                        data.lastUpdate = DateUtils.convertLocalDateFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    copy.lastUpdate = DateUtils.convertLocalDateToServer(copy.lastUpdate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    copy.lastUpdate = DateUtils.convertLocalDateToServer(copy.lastUpdate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
